import { useEffect, useState } from 'react';
import { supabase } from '../supabase';
export function useSubscription(orgId) {
    const [sub, setSub] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (!orgId) {
            setSub(null);
            setLoading(false);
            return;
        }
        let cancelled = false;
        (async () => {
            setLoading(true);
            setError(null);
            const { data, error } = await supabase.from('subscriptions')
                .select('*').eq('org_id', orgId).order('created_at', { ascending: false }).limit(1).maybeSingle();
            if (cancelled)
                return;
            if (error)
                setError(error.message);
            setSub(data);
            setLoading(false);
        })();
        return () => { cancelled = true; };
    }, [orgId]);
    return { sub, loading, error };
}
/**
 * Pulls the live price list via a Supabase Edge function wrapper.
 * If offline or Stripe is not wired, falls back to the plans registered in DB feature_flags.plans.
 */
export function usePrices() {
    const [prices, setPrices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        let cancelled = false;
        (async () => {
            setLoading(true);
            try {
                const url = import.meta.env.VITE_SUPABASE_URL + '/functions/v1/stripe-prices';
                const r = await fetch(url, { headers: { apikey: import.meta.env.VITE_SUPABASE_ANON_KEY } });
                if (r.ok) {
                    const j = await r.json();
                    if (!cancelled)
                        setPrices(j.prices ?? []);
                }
                else {
                    // Fallback: plans stored in DB
                    const { data } = await supabase.from('feature_flags').select('value').eq('key', 'plans.public').maybeSingle();
                    const plans = data?.value?.plans ?? [];
                    if (!cancelled)
                        setPrices(plans);
                }
            }
            catch (e) {
                if (!cancelled)
                    setError(e?.message ?? 'Could not load plans.');
            }
            finally {
                if (!cancelled)
                    setLoading(false);
            }
        })();
        return () => { cancelled = true; };
    }, []);
    return { prices, loading, error };
}
